import createIcon from '@/lib/create-icon'

const BadmintonIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M8.71241 27.5923L16.3439 5.96327C16.3439 5.96327 18.888 3.41849 22.0709 6.60132C25.2538 9.78414 23.9793 13.5986 23.9793 13.5986M8.71241 27.5923L11.2574 30.1383M8.71241 27.5923C4.899 31.4126 3.61829 35.2212 6.80385 38.4065C9.98941 41.5919 13.8014 40.3148 17.6181 36.498M8.71241 27.5923L17.6181 36.498M11.2574 30.1383L23.9793 13.5986M11.2574 30.1383L15.0737 33.9546M23.9793 13.5986C23.9793 13.5986 27.1606 11.691 30.3413 14.8716C33.5219 18.0522 31.6135 21.2328 31.6135 21.2328M17.6181 36.498L39.2488 28.8682C39.2488 28.8682 41.7937 26.324 38.6108 23.1412C35.4279 19.9583 31.6135 21.2328 31.6135 21.2328M17.6181 36.498L15.0737 33.9546M15.0737 33.9546L31.6135 21.2328'
      stroke='url(#paint0_linear_5304_2355)'
      strokeWidth='2.69883'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M8.71241 27.5923L16.3439 5.96327C16.3439 5.96327 18.888 3.41849 22.0709 6.60132C25.2538 9.78414 23.9793 13.5986 23.9793 13.5986M8.71241 27.5923L11.2574 30.1383M8.71241 27.5923C4.899 31.4126 3.61829 35.2212 6.80385 38.4065C9.98941 41.5919 13.8014 40.3148 17.6181 36.498M8.71241 27.5923L17.6181 36.498M11.2574 30.1383L23.9793 13.5986M11.2574 30.1383L15.0737 33.9546M23.9793 13.5986C23.9793 13.5986 27.1606 11.691 30.3413 14.8716C33.5219 18.0522 31.6135 21.2328 31.6135 21.2328M17.6181 36.498L39.2488 28.8682C39.2488 28.8682 41.7937 26.324 38.6108 23.1412C35.4279 19.9583 31.6135 21.2328 31.6135 21.2328M17.6181 36.498L15.0737 33.9546M15.0737 33.9546L31.6135 21.2328'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.69883'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M8.71241 27.5923L16.3439 5.96327C16.3439 5.96327 18.888 3.41849 22.0709 6.60132C25.2538 9.78414 23.9793 13.5986 23.9793 13.5986M8.71241 27.5923L11.2574 30.1383M8.71241 27.5923C4.899 31.4126 3.61829 35.2212 6.80385 38.4065C9.98941 41.5919 13.8014 40.3148 17.6181 36.498M8.71241 27.5923L17.6181 36.498M11.2574 30.1383L23.9793 13.5986M11.2574 30.1383L15.0737 33.9546M23.9793 13.5986C23.9793 13.5986 27.1606 11.691 30.3413 14.8716C33.5219 18.0522 31.6135 21.2328 31.6135 21.2328M17.6181 36.498L39.2488 28.8682C39.2488 28.8682 41.7937 26.324 38.6108 23.1412C35.4279 19.9583 31.6135 21.2328 31.6135 21.2328M17.6181 36.498L15.0737 33.9546M15.0737 33.9546L31.6135 21.2328'
      stroke='url(#paint1_radial_5304_2355)'
      strokeOpacity='0.6'
      strokeWidth='2.69883'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5304_2355'
        x1='5'
        y1='5'
        x2='45.2523'
        y2='32.9537'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5304_2355'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.6061 40.2113) scale(17.6061 17.9309)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'BadmintonIcon'
)

export default BadmintonIcon
